import { useState, useEffect } from 'react';
import { authFetch } from '../utils/api';

export function useForecast() {
  const [data,     setData]     = useState(null);
  const [loading,  setLoading]  = useState(true);
  const [error,    setError]    = useState(null);
  const [lastSync, setLastSync] = useState(null);

  const fetchData = () => {
    setLoading(true);
    setError(null);
    authFetch('/api/forecast')
      .then(r => { if (!r.ok) throw new Error(r.statusText); return r.json(); })
      .then(d  => { setData(d); setLastSync(new Date()); setLoading(false); })
      .catch(e => { setError(e.message); setLoading(false); });
  };

  useEffect(() => { fetchData(); }, []);

  return { data, loading, error, refresh: fetchData, lastSync };
}